import { withTextComponent } from '@updater-legacy/components/custom-element';

export default class PhoneFormatter extends withTextComponent() {
  static observedAttributes = ['value'];
  static reflectedAttributes = ['value'];

  updated({ value }) {
    this.textContent = format(value);
  }
}

customElements.define('upd-phone-formatter', PhoneFormatter);

export function format(value) {
  return standardize(value).replace(
    /^(\d{0,3})(\d{0,3})(\d{0,4})$/,
    (match, p1, p2, p3) =>
      // For incomplete numbers, only apply formatting for parts that matched.
      // E.g.: "333" becomes "(333" instead of "(333) -".
      // This is mainly useful when creating a phone input mask.
      !p1 ? '' : `(${p1}` + (!p2 ? '' : `) ${p2}` + (!p3 ? '' : `-${p3}`))
  );
}

export function standardize(value) {
  return value.replace(/[\D\s]/g, '').substring(0, 10);
}
